import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Container,
  Row,
  Col,
  ListGroup,
  Spinner,
  Stack,
} from "react-bootstrap";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { GalleryItem } from "./GalleryItem";
import { EditMediaButtons } from "./EditMediaButtons";
import { useGetSwapsQuery } from "../../app/services/api";
import { MdFileDownload } from "react-icons/md";
import { setCurrentPage, getCurrentPage, getPageSize } from "./coreSlice";
var classNames = require("classnames");

export const Gallery = () => {
  const { push } = useHistory();
  const dispatch = useDispatch();
  const currentPage = useSelector(getCurrentPage);
  const pageSize = useSelector(getPageSize);
  const {
    data: {
      created_videos: swaps,
      total: totalItems,
      expiring: numExpiringSwaps,
    } = {},
    isLoading,
    isFetching,
  } = useGetSwapsQuery({
    page: currentPage,
    pageSize,
  });
  const [, setNotificationCount] = useState(null);

  const numVisibleItems = swaps?.filter((i) => !i.hidden)?.length;

  // Pagination handles
  const handlePageChange = (pageNumber) => {
    dispatch(setCurrentPage(pageNumber));
  };

  // Render the Pagination component
  const pagination =
    totalItems > pageSize ? (
      <div className="custom-pagination">
        <PaginationControl
          page={currentPage}
          between={3}
          total={totalItems}
          limit={pageSize}
          changePage={handlePageChange}
          ellipsis={2}
        />
      </div>
    ) : null;

  const onBackClicked = () => {
    push("/home");
  };

  useEffect(() => {
    swaps && setNotificationCount(numExpiringSwaps);
  }, [swaps, numExpiringSwaps]);

  return isLoading ? (
    <Container className="mt-3">
      <Row className="mb-3">
        <Col>
          <Stack gap={2} style={{ alignItems: "center" }}>
            <span>Loading content...</span>
            <Spinner animation="border" />
          </Stack>
        </Col>
      </Row>
    </Container>
  ) : (
    <Container className="mx-2 mt-3">
      <Row className="me-2">
        <Col className="px-1">
          <div
            className="alert alert-info py-1 px-2 border-0"
            style={{
              fontSize: "0.8rem",
              backgroundColor: "#e9f5fb", // slightly deeper blue than before
              color: "rgb(107, 131, 152)",
              fontStyle: "italic",
            }}
          >
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <span>{"\u24D8"}</span>
              <div style={{ marginLeft: "0.5em" }}>
                New swaps are deleted automatically after 24h.
                <br />
                Click <MdFileDownload /> to download files you want to keep.
              </div>
            </div>
          </div>
          <h2>{"Gallery"}</h2>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col className="px-0">
          <div className="d-flex flex-row">
            <Button variant="secondary" onClick={onBackClicked}>
              Back
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <div className="d-flex flex-row">{pagination}</div>
        </Col>
      </Row>
      {numVisibleItems > 0 || isLoading || isFetching ? null : (
        <Row className="my-2">
          <Col>{<i>{"No swaps created yet."}</i>}</Col>
        </Row>
      )}
      <Row>
        <Col>
          {isFetching ? (
            <Stack className="my-4" gap={2} style={{ alignItems: "center" }}>
              <span>Loading swaps...</span>
              <Spinner animation="border" />
            </Stack>
          ) : (
            <ListGroup variant="flush" className="px-0">
              {swaps?.map((swap) => {
                let willDeleteSoon = swap.days_left <= 7;
                var listGroupRowClass = classNames({
                  "align-items-center": true,
                  "scroll-item-will-delete": willDeleteSoon,
                });

                return (
                  <Container key={swap.id} className="px-0">
                    <Row className={listGroupRowClass} xs="auto">
                      <Col className="px-0">
                        <GalleryItem swap={swap} editMode={true} />
                      </Col>
                      {
                        <Col className="px-0">
                          <div className="d-flex flex-column">
                            <EditMediaButtons type={"swap"} item={swap} />
                          </div>
                        </Col>
                      }
                    </Row>
                  </Container>
                );
              })}
            </ListGroup>
          )}
        </Col>
      </Row>
      {isFetching ? null : (
        <Row>
          <Col className="px-0">
            <div className="d-flex flex-row mb-2">{pagination}</div>
          </Col>
        </Row>
      )}
    </Container>
  );
};
